import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../IndividualPlan/tokens';

export const FindingsListRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export const FindingRow = styled(Box)({
  display: 'flex',
  gap: 12,
  alignItems: 'flex-start',
  padding: '16px 20px',
  border: `1px solid ${COLORS.divider}`,
  borderRadius: 8,
});

export const FindingOrdinal = styled(Box)({
  flexShrink: 0,
  width: 32,
  height: 32,
  borderRadius: 9999,
  backgroundColor: COLORS.navy,
  color: '#FFFFFF',
  fontWeight: 700,
  fontSize: 16,
  lineHeight: '32px',
  textAlign: 'center',
  fontVariantNumeric: 'tabular-nums',
});

export const FindingBody = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  flex: 1,
});
